import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { FlowOfFunds } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface AgreeToVetValueFeesArg {
    engagementId: number;
    agreed: boolean;
}

export const AgreeToVetValueFees = createAsyncThunk(
    'flowOfFunds/agreeToVetValueFees',
    async (arg: AgreeToVetValueFeesArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/FlowOfFunds/${arg.engagementId}/VetValueFees/Agree`,
                { agreed: arg.agreed }
            );

            if (response.status !== 200) {
                throw new Error('Failed to record the fee agreement');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification(
                'There was an error while recording the fee agreement.',
                'error'
            );
            throw error;
        }
    }
);
